export const SET_ATTRIBUTE = "SET_ATTRIBUTE";
export const SET_ATTRIBUTES = "SET_ATTRIBUTES";
export const ADD_ATTRIBUTE = "ADD_ATTRIBUTE";
export const UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE";
export const DELETE_ATTRIBUTE = "DELETE_ATTRIBUTE";
